const value = {
    table: {
      active: 'Active',
    },
    deleteRowModal: {
      title: 'Delete the profile',
      message: 'There are no users participating in projects in this LDAP profile.',
      confirmationMessage: 'Are you sure you want to delete {{name}} profile?',
    },
    unableToDeleteRowModal: {
      title: 'Unable to delete the profile',
      message1:
        'This LDAP profile contains users participating in projects. To delete the {{name}} profile, you must unlink users from projects.',
      message2: 'Users participating in projects in a given LDAP profile:',
      inProjects: 'in projects',
    },
    addModal: {
      title: 'Add Active Directory',
      useAuthenticationWithThisASByDefault: 'Use authentication with this AS by default:',
      activateThisConnection: 'Activate this connection:',
      addLink: 'Add link',
      fillBothFields: 'Please fill both fields',
    },
  };

export default value;
